<template lang="pug">
header.products
  .products__tools(:style="top")
    button.products__toggle.btn.btn--outline(
      v-if="!disableAdd || !disableRemove"
      @click="disableRemove ? false : removeComparison()"
      :disabled="disableRemove") -
    button.products__toggle.btn.btn--dark(
      v-if="!disableAdd || !disableRemove"
      @click="disableAdd ? false : addComparison()"
      :disabled="disableAdd") +
  .products__content(:style="top")
    TransitionToggle
      AppProduct(v-for="product, i in products", :key="i", :product="product", :index="i", ref="product")
</template>

<script>
import AppProduct from './Product.vue'
import TransitionToggle from '../transitions/Toggle.vue'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: "AppProducts",
  components: {
    AppProduct,
    TransitionToggle
  },
  data() {
    return {
      media: window.matchMedia('(min-width: 768px)'),
      top: '0px'
    }
  },
  computed: {
    ...mapGetters(['products', 'max', 'size']),
    disableRemove() {
      return this.size <= 2;
    },
    disableAdd() {
      return this.size >= this.max;
    },
  },
  methods: {
    ...mapMutations(['addComparison', 'removeComparison']),
    setTop() {
			let headerHeight = document.querySelector('.header__inner').offsetHeight;
			this.top = `top: ${headerHeight}px`;
    }
  },
  mounted() {
    setTimeout(this.setTop, 500);
    window.addEventListener('resize', this.setTop);
  }
}
</script>

<style lang="scss" scoped>
.products {
  display: contents;

  &__tools {
    @include cell(true);
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: end;
    gap: 0.5rem;
    position: sticky;
    top: 0;
    z-index: 9;
  }

  &__toggle {
    filter: grayscale(0%);
    opacity: 1;
    transition-property: filter, opacity;
    transition-duration: 0.2s;
    transition-timing-function: ease;
    margin: 0;
    padding: 0 0.5rem;
    height: 36px;
    width: auto;
    outline: none;

    &:disabled {
      pointer-events: none;
      filter: grayscale(50%);
      opacity: 0.5;
    }

    &:focus {
      outline: none;
    }
  }

  &__content {
    display: flex;
    grid-column: 2 / 3;
    grid-row: span 1;
    position: sticky;
    top: 0;
    z-index: 9;
  }
}
</style>
